import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import NumericInput from "react-numeric-input";

const SettingsCountingArea = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const data = props.data;

  const jwt = localStorage.getItem("JWT");
  const link = localStorage.getItem("link");

  const rights = JSON.parse(localStorage.getItem("rights") || "[]");
  const canEditOcc = rights.includes("Area.SetExternalOccupation");
  const canEditConst = rights.includes("Area.SetExternalConstructed");

  const [constructed, setConstructed] = useState(null);
  const [occupied, setOccupied] = useState(null);

  const [origConstructed, setOrigConstructed] = useState(null);
  const [origOccupied, setOrigOccupied] = useState(null);

  const [saving, setSaving] = useState(false);

  const isDirty = () =>
    (canEditConst && constructed !== origConstructed) ||
    (canEditOcc && occupied !== origOccupied);

  const reset = () => {
    setConstructed(origConstructed);
    setOccupied(origOccupied);
  };

  const save = async () => {
    if (!isDirty() || saving) return;

    setSaving(true);

    try {
      const requests = [];

      if (canEditConst && constructed !== origConstructed) {
        requests.push(
          axios.put(
            link +
              "/api/Area/ExternalConstructed?areaId=" +
              data.id +
              "&capacity=" +
              constructed,
            {
              headers: {
                Authorization: "Bearer " + jwt,
              },
            },
          ),
        );
      }

      if (canEditOcc && occupied !== origOccupied) {
        requests.push(
          axios.put(
            link +
              "/api/Area/ExternalOccupation?areaId=" +
              data.id +
              "&occupation=" +
              occupied,
            {
              headers: {
                Authorization: "Bearer " + jwt,
              },
            },
          ),
        );
      }

      await Promise.all(requests);

      setOrigConstructed(constructed);
      setOrigOccupied(occupied);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const c = data?.areaValues?.constructed ?? null;
    const o = data?.areaValues?.displayValueForOccupied ?? null;

    setConstructed(c);
    setOccupied(o);

    setOrigConstructed(c);
    setOrigOccupied(o);
  }, [data]);

  useImperativeHandle(ref, () => ({
    isDirty,
    save,
    reset,
  }));

  return (
    <>
      {canEditConst && (
        <div className="settings-groups">
          <div className="settings-name">
            {t("elementeAllgemein.areaWerte.Constructed")}
          </div>

          <NumericInput
            className="input-numeric input100"
            value={constructed}
            min={0}
            onChange={setConstructed}
          />
        </div>
      )}

      {canEditOcc && (
        <div className="settings-groups">
          <div className="settings-name">
            {t("elementeAllgemein.areaWerte.Occupied")}
          </div>

          <NumericInput
            className="input-numeric input100"
            value={occupied}
            min={0}
            onChange={setOccupied}
          />
        </div>
      )}
    </>
  );
});

export default SettingsCountingArea;
